<template>
    <div class="functions_menu"></div>
</template>

<script>

export default {
    data () {
        return {
        }
    },  
    mounted(){
        this.app_Js();
        this.app_init_horizontal_fullwidth_Js();
        this.app_style_switcher_horizontal_Js();
        this.perfect_scrollbar_jquery_Js();
        this.sparkline_Js();
        this.waves_Js();
        //this.sidebarmenu_Js();
        this.custom_Js();
    }, 
    methods:{
        app_Js(){
            $.fn.AdminSettings = function (settings) {
                var myid = this.attr("id");
                // General option for vertical header 
                var defaults = {
                    Theme: true, // this can be true or false ( true means dark and false means light ),
                    Layout: 'vertical', // 
                    LogoBg: 'skin1', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6 
                    NavbarBg: 'skin6', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6 
                    SidebarType: 'full', // You can change it full / mini-sidebar
                    SidebarColor: 'skin1', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6
                    SidebarPosition: false, // it can be true / false
                    HeaderPosition: false, // it can be true / false
                    BoxedLayout: false, // it can be true / false 
                };
                var settings = $.extend({}, defaults, settings);
                // Attribute functions 
                var AdminSettings = {
                    // Settings INIT
                    AdminSettingsInit: function () {
                        AdminSettings.ManageTheme();
                        AdminSettings.ManageThemeLayout();
                        AdminSettings.ManageThemeBackground();
                        AdminSettings.ManageSidebarType();
                        AdminSettings.ManageSidebarColor();
                        AdminSettings.ManageSidebarPosition();
                        AdminSettings.ManageBoxedLayout();
                    }
                    , //****************************
                    // ManageThemeLayout functions
                    //****************************
                    ManageTheme: function () {
                        var themeview = settings.Theme;
                        switch (settings.Layout) {
                        case 'vertical', 'horizontal':
                            if (themeview == true) {
                                $('body').attr("data-theme", 'dark');
                                $("#theme-view").prop("checked", !0);
                            }
                            else {
                                $('#' + myid).attr("data-theme", 'light');
                                $("body").prop("checked", !1);
                            }
                            break;

                               
                        default:
                        }
                    }
                    , //****************************
                    // ManageThemeLayout functions
                    //****************************
                    ManageThemeLayout: function () {
                        switch (settings.Layout) {
                        case 'horizontal':
                            $('#' + myid).attr("data-layout", "horizontal");
                            break;
                        case 'vertical':
                            $('#' + myid).attr("data-layout", "vertical");
                            $('.scroll-sidebar').perfectScrollbar({ });
                            break;
                        default:
                        }
                    }
                    , //****************************
                    // ManageSidebarType functions 
                    //****************************
                    ManageThemeBackground: function () {
                        // Logo bg attribute
                        function setlogobg() {
                            var lbg = settings.LogoBg;
                            if (lbg != undefined && lbg != "") {
                                $('#' + myid + ' .topbar .top-navbar .navbar-header').attr("data-logobg", lbg);
                            }
                            else {
                                $('#' + myid + ' .topbar .top-navbar .navbar-header').attr("data-logobg", "skin1");
                            }
                        };
                        setlogobg();
                        // Navbar bg attribute
                        function setnavbarbg() {
                            var nbg = settings.NavbarBg;
                            if (nbg != undefined && nbg != "") {
                                $('#' + myid + ' .topbar .navbar-collapse').attr("data-navbarbg", nbg);
                                $('#' + myid + ' .topbar').attr("data-navbarbg", nbg);
                                $('#' + myid).attr("data-navbarbg", nbg);
                            }
                            else {
                                $('#' + myid + ' .topbar .navbar-collapse').attr("data-navbarbg", "skin1");
                                 $('#' + myid + ' .topbar').attr("data-navbarbg", "skin1");
                                $('#' + myid).attr("data-navbarbg", "skin1");
                            }
                        };
                        setnavbarbg();
                    }
                    , //****************************
                    // ManageThemeLayout functions
                    //****************************
                    ManageSidebarType: function () {
                        switch (settings.SidebarType) {
                            //****************************
                            // If the sidebar type has full
                            //****************************     
                        case 'full':
                            $('#' + myid).attr("data-sidebartype", "full");
                            //****************************
                            /* This is for the mini-sidebar if width is less then 1170*/
                            //**************************** 
                            var setsidebartype = function () {
                                var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
                                if (width < 1170) {
                                    $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                                }
                                else {
                                    $("#main-wrapper").attr("data-sidebartype", "full");
                                }
                            };
                            $(window).ready(setsidebartype);
                            $(window).on("resize", setsidebartype);
                            //****************************
                            /* This is for sidebartoggler*/
                            //****************************
                            $('.sidebartoggler').on("click", function () {
                                $("#main-wrapper").toggleClass("mini-sidebar");
                                if ($("#main-wrapper").hasClass("mini-sidebar")) {
                                    $(".sidebartoggler").prop("checked", !0);
                                    $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                                }
                                else {
                                    $(".sidebartoggler").prop("checked", !1);
                                    $("#main-wrapper").attr("data-sidebartype", "full");
                                }
                            });
                            break;
                            //****************************
                            // If the sidebar type has mini-sidebar
                            //****************************       
                        case 'mini-sidebar':
                            $('#' + myid).attr("data-sidebartype", "mini-sidebar");
                            //****************************
                            /* This is for sidebartoggler*/
                            //****************************
                            $('.sidebartoggler').on("click", function () {
                                $("#main-wrapper").toggleClass("mini-sidebar");
                                if ($("#main-wrapper").hasClass("mini-sidebar")) {
                                    $(".sidebartoggler").prop("checked", !0);
                                    $("#main-wrapper").attr("data-sidebartype", "full");
                                }
                                else {
                                    $(".sidebartoggler").prop("checked", !1);
                                    $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                                }
                            });
                            break;
                            //****************************
                            // If the sidebar type has iconbar
                            //****************************       
                        case 'iconbar':
                            $('#' + myid).attr("data-sidebartype", "iconbar");
                            //****************************
                            /* This is for the mini-sidebar if width is less then 1170*/
                            //**************************** 
                            var setsidebartype = function () {
                                var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
                                if (width < 1170) {
                                    $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                                    $("#main-wrapper").addClass("mini-sidebar");
                                }
                                else {
                                    $("#main-wrapper").attr("data-sidebartype", "iconbar");
                                    $("#main-wrapper").removeClass("mini-sidebar");
                                }
                            };
                            $(window).ready(setsidebartype);
                            $(window).on("resize", setsidebartype);
                            //****************************
                            /* This is for sidebartoggler*/
                            //****************************
                            $('.sidebartoggler').on("click", function () {
                                $("#main-wrapper").toggleClass("mini-sidebar");
                                if ($("#main-wrapper").hasClass("mini-sidebar")) {
                                    $(".sidebartoggler").prop("checked", !0);
                                    $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                                }
                                else {
                                    $(".sidebartoggler").prop("checked", !1);
                                    $("#main-wrapper").attr("data-sidebartype", "iconbar");
                                }
                            });
                            break;
                            //****************************
                            // If the sidebar type has overlay
                            //****************************       
                        case 'overlay':
                            $('#' + myid).attr("data-sidebartype", "overlay");
                            var setsidebartype = function () {
                                var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
                                if (width < 767) {
                                    $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                                    $("#main-wrapper").addClass("mini-sidebar");
                                }
                                else {
                                    $("#main-wrapper").attr("data-sidebartype", "overlay");
                                    $("#main-wrapper").removeClass("mini-sidebar");
                                }
                            };
                            $(window).ready(setsidebartype);
                            $(window).on("resize", setsidebartype);
                            //****************************
                            /* This is for sidebartoggler*/
                            //****************************
                            $('.sidebartoggler').on("click", function () {
                                $("#main-wrapper").toggleClass("show-sidebar");
                                if ($("#main-wrapper").hasClass("show-sidebar")) {
                                    //$(".sidebartoggler").prop("checked", !0);
                                    //$("#main-wrapper").attr("data-sidebartype","mini-sidebar");
                                }
                                else {
                                    //$(".sidebartoggler").prop("checked", !1);
                                    //$("#main-wrapper").attr("data-sidebartype","iconbar");
                                }
                            });
                            break;
                        default:
                        }
                    }
                    , //****************************
                    // ManageSidebarColor functions 
                    //****************************
                    ManageSidebarColor: function () {
                        // Logo bg attribute
                        function setsidebarbg() {
                            var sbg = settings.SidebarColor;
                            if (sbg != undefined && sbg != "") {
                                $('#' + myid + ' .left-sidebar').attr("data-sidebarbg", sbg);
                            }
                            else {
                                $('#' + myid + ' .left-sidebar').attr("data-sidebarbg", "skin1");
                            }
                        };
                        setsidebarbg();
                    }
                    , //****************************
                    // ManageSidebarPosition functions
                    //****************************
                    ManageSidebarPosition: function () {
                        var sidebarposition = settings.SidebarPosition;
                        var headerposition = settings.HeaderPosition;
                        switch (settings.Layout) {
                        case 'vertical':
                            if (sidebarposition == true) {
                                $('#' + myid).attr("data-sidebar-position", 'fixed');
                                $("#sidebar-position").prop("checked", !0);
                            }
                            else {
                                $('#' + myid).attr("data-sidebar-position", 'absolute');
                                $("#sidebar-position").prop("checked", !1);
                            }
                            if (headerposition == true) {
                                $('#' + myid).attr("data-header-position", 'fixed');
                                $("#header-position").prop("checked", !0);
                            }
                            else {
                                $('#' + myid).attr("data-header-position", 'relative');
                                $("#header-position").prop("checked", !1);
                            }
                            break;
                        default:
                        }
                    }
                    , //****************************
                    // ManageBoxedLayout functions
                    //****************************
                    ManageBoxedLayout: function () {
                        var boxedlayout = settings.BoxedLayout;
                        switch (settings.Layout) {
                        case 'vertical':
                            if (boxedlayout == true) {
                                $('#' + myid).attr("data-boxed-layout", 'boxed');
                                $("#boxed-layout").prop("checked", !0);
                            }
                            else {
                                $('#' + myid).attr("data-boxed-layout", 'full');
                                $("#boxed-layout").prop("checked", !1);
                            }
                            break;
                        case 'horizontal':
                            if (boxedlayout == true) {
                                $('#' + myid).attr("data-boxed-layout", 'boxed');
                                $("#boxed-layout").prop("checked", !0);
                            }
                            else {
                                $('#' + myid).attr("data-boxed-layout", 'full');
                                $("#boxed-layout").prop("checked", !1);
                            }
                            break;        
                        default:
                        }
                    }
                , };
                AdminSettings.AdminSettingsInit();
            };
            //****************************
            // This is for the chat customizer setting
            //****************************
            $(function () {
                var chatarea = $("#chat");
                $('#chat .message-center a').on('click', function () {
                    var name = $(this).find(".mail-contnet h5").text();
                    var img = $(this).find(".user-img img").attr("src");
                    var id = $(this).attr("data-user-id");
                    var status = $(this).find(".profile-status").attr("data-status");
                    if ($(this).hasClass("active")) {
                        $(this).toggleClass("active");
                        $(".chat-windows #user-chat" + id).hide();
                    }
                    else {
                        $(this).toggleClass("active");
                        if ($(".chat-windows #user-chat" + id).length) {
                            $(".chat-windows #user-chat" + id).removeClass("mini-chat").show();
                        }
                        else {
                            var msg = msg_receive('I watched the storm, so beautiful yet terrific.');
                            msg += msg_sent('That is very deep indeed!');
                            var html = "<div class='user-chat' id='user-chat" + id + "' data-user-id='" + id + "'>";
                            html += "<div class='chat-head'><img src='" + img + "' data-user-id='" + id + "'><span class='status " + status + "'></span><span class='name'>" + name + "</span><span class='opts'><i class='ti-close closeit' data-user-id='" + id + "'></i><i class='ti-minus mini-chat' data-user-id='" + id + "'></i></span></div>";
                            html += "<div class='chat-body'><ul class='chat-list'>" + msg + "</ul></div>";
                            html += "<div class='chat-footer'><input type='text' data-user-id='" + id + "' placeholder='Type & Enter' class='form-control'></div>";
                            html += "</div>";
                            $(".chat-windows").append(html);
                        }
                    }
                });
                $(document).on('click', ".chat-windows .user-chat .chat-head .closeit", function (e) {
                    var id = $(this).attr("data-user-id");
                    $(".chat-windows #user-chat" + id).hide();
                    $("#chat .message-center .user-info#chat_user_" + id).removeClass("active");
                });
                $(document).on('click', ".chat-windows .user-chat .chat-head img, .chat-windows .user-chat .chat-head .mini-chat", function (e) {
                    var id = $(this).attr("data-user-id");
                    if (!$(".chat-windows #user-chat" + id).hasClass("mini-chat")) {
                        $(".chat-windows #user-chat" + id).addClass("mini-chat");
                    }
                    else {
                        $(".chat-windows #user-chat" + id).removeClass("mini-chat");
                    }
                });
                $(document).on('keypress', ".chat-windows .user-chat .chat-footer input", function (e) {
                    if (e.keyCode == 13) {
                        var id = $(this).attr("data-user-id");
                        var msg = $(this).val();
                        msg = msg_sent(msg);
                        $(".chat-windows #user-chat" + id + " .chat-body .chat-list").append(msg);
                        $(this).val("");
                        $(this).focus();
                    }
                    $(".chat-windows #user-chat" + id + " .chat-body").perfectScrollbar({
                        suppressScrollX: true
                    });
                });
                $(".page-wrapper").on('click', function (e) {
                    $('.chat-windows').addClass('hide-chat');
                    $('.chat-windows').removeClass('show-chat');
                });
                $(".service-panel-toggle").on('click', function (e) {
                    $('.chat-windows').addClass('show-chat');
                    $('.chat-windows').removeClass('hide-chat');
                });
            });

            function msg_receive(msg) {
                var d = new Date();
                var h = d.getHours();
                var m = d.getMinutes();
                return "<li class='msg_receive'><div class='chat-content'><div class='box bg-light-info'>" + msg + "</div></div><div class='chat-time'>" + h + ":" + m + "</div></li>";
            }

            function msg_sent(msg) {
                var d = new Date();
                var h = d.getHours();
                var m = d.getMinutes();
                return "<li class='odd msg_sent'><div class='chat-content'><div class='box bg-light-info'>" + msg + "</div><br></div><div class='chat-time'>" + h + ":" + m + "</div></li>";
            }
        },
        app_init_horizontal_fullwidth_Js(){
            $(function() {
                "use strict";
                $("#main-wrapper").AdminSettings({
                    Theme: false, // this can be true or false ( true means dark and false means light ),
                    Layout: 'horizontal',
                    LogoBg: 'skin1', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6 
                    NavbarBg: 'skin1', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6
                    SidebarType: 'full', // You can change it full / mini-sidebar / iconbar / overlay
                    SidebarColor: 'skin6', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6
                    SidebarPosition: false, // it can be true / false ( true means Fixed and false means absolute )
                    HeaderPosition: false, // it can be true / false ( true means Fixed and false means absolute )
                    BoxedLayout: false, // it can be true / false ( true means Boxed and false means Fluid ) 
                });
            });
        },
        app_style_switcher_horizontal_Js(){
            $(function() {
                "use strict";
                //****************************
                /* Left header Theme Change function Start */
                //****************************
                function handlelogobg() {
                    $('.theme-color .theme-item .theme-link').on("click", function() {
                        var logobgskin = $(this).attr("data-logobg");
                        $('.topbar .top-navbar .navbar-header').attr("data-logobg", logobgskin);
                    });
                };
                handlelogobg();
                //****************************
                /* Top navbar Theme Change function Start */
                //****************************
                function handlenavbarbg() {
                    if ( $('#main-wrapper').attr('data-navbarbg') == 'skin6' ) {
                                // do this
                                $(".topbar .navbar").addClass('navbar-light');
                                $(".topbar .navbar").removeClass('navbar-dark');
                            } else {
                                // do that
                                
                            }
                    $('.theme-color .theme-item .theme-link').on("click", function() {
                        var navbarbgskin = $(this).attr("data-navbarbg");
                        $('#main-wrapper').attr("data-navbarbg", navbarbgskin);
                        $('.topbar').attr("data-navbarbg", navbarbgskin);
                        $('.topbar .navbar-collapse').attr("data-navbarbg", navbarbgskin);
                        if ( $('#main-wrapper').attr('data-navbarbg') == 'skin6' ) {
                                // do this
                                $(".topbar .navbar").addClass('navbar-light');
                                $(".topbar .navbar").removeClass('navbar-dark');
                            } else {
                                // do that
                                $(".topbar .navbar").removeClass('navbar-light');
                                $(".topbar .navbar").addClass('navbar-dark');
                            }
                    });
                    
                };

                handlenavbarbg();
                
                //****************************
                // ManageSidebar Type
                //****************************
                function handlesidebartype() {
                    
                };
                handlesidebartype();
                 
                
                //****************************
                /* Manage sidebar bg color */
                //****************************
                function handlesidebarbg() {
                    $('.theme-color .theme-item .theme-link').on("click", function() {
                        var sidebarbgskin = $(this).attr("data-sidebarbg");
                        $('.left-sidebar').attr("data-sidebarbg", sidebarbgskin);
                    });
                };
                handlesidebarbg();
                //****************************
                /* sidebar position */
                //****************************
                function handlesidebarposition() {
                    $('#sidebar-position').change(function() {
                        if( $(this).is(":checked")) {
                            $('#main-wrapper').attr("data-sidebar-position", 'fixed' );
                            $('.topbar .top-navbar .navbar-header').attr("data-navheader", 'fixed' );
                        }else {
                            $('#main-wrapper').attr("data-sidebar-position", 'absolute' ); 
                            $('.topbar .top-navbar .navbar-header').attr("data-navheader", 'relative' );
                        }
                    });
                    
                };
                handlesidebarposition ();
                //****************************
                /* Header position */
                //****************************
                function handleheaderposition() {
                    $('#header-position').change(function() {
                        if( $(this).is(":checked")) {
                            $('#main-wrapper').attr("data-header-position", 'fixed' );
                        }else {
                            $('#main-wrapper').attr("data-header-position", 'relative' ); 
                        }      
                    });
                };
                handleheaderposition ();
                //****************************
                /* sidebar position */
                //****************************
                function handleboxedlayout() {
                    $('#boxed-layout').change(function() {
                        if( $(this).is(":checked")) {
                            $('#main-wrapper').attr("data-boxed-layout", 'boxed' );
                        }else {
                            $('#main-wrapper').attr("data-boxed-layout", 'full' ); 
                        }
                    });
                    
                };
                handleboxedlayout ();
                //****************************
                /* Header position */
                //****************************
                function handlethemeview() {
                    $('#theme-view').change(function() {
                        if( $(this).is(":checked")) {
                            $('body').attr("data-theme", 'dark' );
                        }else {
                            $('body').attr("data-theme", 'light' ); 
                        }      
                    });
                };
                handlethemeview ();
            });
        },
        perfect_scrollbar_jquery_Js(){
            /* perfect-scrollbar v0.6.10 */
            (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
            'use strict';

            var ps = require('../main')
              , psInstances = require('../plugin/instances');

            function mountJQuery(jQuery) {
              jQuery.fn.perfectScrollbar = function (settingOrCommand) {
                return this.each(function () {
                  if (typeof settingOrCommand === 'object' ||
                      typeof settingOrCommand === 'undefined') {
                    // If it's an object or none, initialize.
                    var settings = settingOrCommand;

                    if (!psInstances.get(this)) {
                      ps.initialize(this, settings);
                    }
                  } else {
                    // Unless, it may be a command.
                    var command = settingOrCommand;

                    if (command === 'update') {
                      ps.update(this);
                    } else if (command === 'destroy') {
                      ps.destroy(this);
                    }
                  }

                  return jQuery(this);
                });
              };
            }

            if (typeof define === 'function' && define.amd) {
              // AMD. Register as an anonymous module.
              define(['jquery'], mountJQuery);
            } else {
              var jq = window.jQuery ? window.jQuery : window.$;
              if (typeof jq !== 'undefined') {
                mountJQuery(jq);
              }
            }

            module.exports = mountJQuery;

            },{"../main":7,"../plugin/instances":18}],2:[function(require,module,exports){
            'use strict';

            function oldAdd(element, className) {
              var classes = element.className.split(' ');
              if (classes.indexOf(className) < 0) {
                classes.push(className);
              }
              element.className = classes.join(' ');
            }

            function oldRemove(element, className) {
              var classes = element.className.split(' ');
              var idx = classes.indexOf(className);
              if (idx >= 0) {
                classes.splice(idx, 1);
              }
              element.className = classes.join(' ');
            }

            exports.add = function (element, className) {
              if (element.classList) {
                element.classList.add(className);
              } else {
                oldAdd(element, className);
              }
            };

            exports.remove = function (element, className) {
              if (element.classList) {
                element.classList.remove(className);
              } else {
                oldRemove(element, className);
              }
            };

            exports.list = function (element) {
              if (element.classList) {
                return Array.prototype.slice.apply(element.classList);
              } else {
                return element.className.split(' ');
              }
            };

            },{}],3:[function(require,module,exports){
            'use strict';

            var DOM = {};

            DOM.e = function (tagName, className) {
              var element = document.createElement(tagName);
              element.className = className;
              return element;
            };

            DOM.appendTo = function (child, parent) {
              parent.appendChild(child);
              return child;
            };

            function cssGet(element, styleName) {
              return window.getComputedStyle(element)[styleName];
            }

            function cssSet(element, styleName, styleValue) {
              if (typeof styleValue === 'number') {
                styleValue = styleValue.toString() + 'px';
              }
              element.style[styleName] = styleValue;
              return element;
            }

            function cssMultiSet(element, obj) {
              for (var key in obj) {
                var val = obj[key];
                if (typeof val === 'number') {
                  val = val.toString() + 'px';
                }
                element.style[key] = val;
              }
              return element;
            }

            DOM.css = function (element, styleNameOrObject, styleValue) {
              if (typeof styleNameOrObject === 'object') {
                // multiple set with object
                return cssMultiSet(element, styleNameOrObject);
              } else {
                if (typeof styleValue === 'undefined') {
                  return cssGet(element, styleNameOrObject);
                } else {
                  return cssSet(element, styleNameOrObject, styleValue);
                }
              }
            };

            DOM.matches = function (element, query) {
              if (typeof element.matches !== 'undefined') {
                return element.matches(query);
              } else {
                if (typeof element.matchesSelector !== 'undefined') {
                  return element.matchesSelector(query);
                } else if (typeof element.webkitMatchesSelector !== 'undefined') {
                  return element.webkitMatchesSelector(query);
                } else if (typeof element.mozMatchesSelector !== 'undefined') {
                  return element.mozMatchesSelector(query);
                } else if (typeof element.msMatchesSelector !== 'undefined') {
                  return element.msMatchesSelector(query);
                }
              }
            };

            DOM.remove = function (element) {
              if (typeof element.remove !== 'undefined') {
                element.remove();
              } else {
                if (element.parentNode) {
                  element.parentNode.removeChild(element);
                }
              }
            };

            DOM.queryChildren = function (element, selector) {
              return Array.prototype.filter.call(element.childNodes, function (child) {
                return DOM.matches(child, selector);
              });
            };

            module.exports = DOM;

            },{}],4:[function(require,module,exports){
            'use strict';

            var EventElement = function (element) {
              this.element = element;
              this.events = {};
            };

            EventElement.prototype.bind = function (eventName, handler) {
              if (typeof this.events[eventName] === 'undefined') {
                this.events[eventName] = [];
              }
              this.events[eventName].push(handler);
              this.element.addEventListener(eventName, handler, false);
            };

            EventElement.prototype.unbind = function (eventName, handler) {
              var isHandlerProvided = (typeof handler !== 'undefined');
              this.events[eventName] = this.events[eventName].filter(function (hdlr) {
                if (isHandlerProvided && hdlr !== handler) {
                  return true;
                }
                this.element.removeEventListener(eventName, hdlr, false);
                return false;
              }, this);
            };

            EventElement.prototype.unbindAll = function () {
              for (var name in this.events) {
                this.unbind(name);
              }
            };

            var EventManager = function () {
              this.eventElements = [];
            };

            EventManager.prototype.eventElement = function (element) {
              var ee = this.eventElements.filter(function (eventElement) {
                return eventElement.element === element;
              })[0];
              if (typeof ee === 'undefined') {
                ee = new EventElement(element);
                this.eventElements.push(ee);
              }
              return ee;
            };

            EventManager.prototype.bind = function (element, eventName, handler) {
              this.eventElement(element).bind(eventName, handler);
            };

            EventManager.prototype.unbind = function (element, eventName, handler) {
              this.eventElement(element).unbind(eventName, handler);
            };

            EventManager.prototype.unbindAll = function () {
              for (var i = 0; i < this.eventElements.length; i++) {
                this.eventElements[i].unbindAll();
              }
            };

            EventManager.prototype.once = function (element, eventName, handler) {
              var ee = this.eventElement(element);
              var onceHandler = function (e) {
                ee.unbind(eventName, onceHandler);
                handler(e);
              };
              ee.bind(eventName, onceHandler);
            };

            module.exports = EventManager;

            },{}],5:[function(require,module,exports){
            'use strict';

            module.exports = (function () {
              function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                           .toString(16)
                           .substring(1);
              }
              return function () {
                return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                       s4() + '-' + s4() + s4() + s4();
              };
            })();

            },{}],6:[function(require,module,exports){
            'use strict';

            var cls = require('./class')
              , d = require('./dom');

            exports.toInt = function (x) {
              return parseInt(x, 10) || 0;
            };

            exports.clone = function (obj) {
              if (obj === null) {
                return null;
              } else if (typeof obj === 'object') {
                var result = {};
                for (var key in obj) {
                  result[key] = this.clone(obj[key]);
                }
                return result;
              } else {
                return obj;
              }
            };

            exports.extend = function (original, source) {
              var result = this.clone(original);
              for (var key in source) {
                result[key] = this.clone(source[key]);
              }
              return result;
            };

            exports.isEditable = function (el) {
              return d.matches(el, "input,[contenteditable]") ||
                     d.matches(el, "select,[contenteditable]") ||
                     d.matches(el, "textarea,[contenteditable]") ||
                     d.matches(el, "button,[contenteditable]");
            };

            exports.removePsClasses = function (element) {
              var clsList = cls.list(element);
              for (var i = 0; i < clsList.length; i++) {
                var className = clsList[i];
                if (className.indexOf('ps-') === 0) {
                  cls.remove(element, className);
                }
              }
            };

            exports.outerWidth = function (element) {
              return this.toInt(d.css(element, 'width')) +
                     this.toInt(d.css(element, 'paddingLeft')) +
                     this.toInt(d.css(element, 'paddingRight')) +
                     this.toInt(d.css(element, 'borderLeftWidth')) +
                     this.toInt(d.css(element, 'borderRightWidth'));
            };

            exports.startScrolling = function (element, axis) {
              cls.add(element, 'ps-in-scrolling');
              if (typeof axis !== 'undefined') {
                cls.add(element, 'ps-' + axis);
              } else {
                cls.add(element, 'ps-x');
                cls.add(element, 'ps-y');
              }
            };

            exports.stopScrolling = function (element, axis) {
              cls.remove(element, 'ps-in-scrolling');
              if (typeof axis !== 'undefined') {
                cls.remove(element, 'ps-' + axis);
              } else {
                cls.remove(element, 'ps-x');
                cls.remove(element, 'ps-y');
              }
            };

            exports.env = {
              isWebKit: 'WebkitAppearance' in document.documentElement.style,
              supportsTouch: (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),
              supportsIePointer: window.navigator.msMaxTouchPoints !== null
            };

            },{"./class":2,"./dom":3}],7:[function(require,module,exports){
            'use strict';

            var destroy = require('./plugin/destroy')
              , initialize = require('./plugin/initialize')
              , update = require('./plugin/update');

            module.exports = {
              initialize: initialize,
              update: update,
              destroy: destroy
            };

            },{"./plugin/destroy":9,"./plugin/initialize":17,"./plugin/update":21}],8:[function(require,module,exports){
            'use strict';

            module.exports = {
              maxScrollbarLength: null,
              minScrollbarLength: null,
              scrollXMarginOffset: 0,
              scrollYMarginOffset: 0,
              stopPropagationOnClick: true,
              suppressScrollX: false,
              suppressScrollY: false,
              swipePropagation: true,
              useBothWheelAxes: false,
              useKeyboard: true,
              useSelectionScroll: false,
              wheelPropagation: false,
              wheelSpeed: 1,
              theme: 'default'
            };

            },{}],9:[function(require,module,exports){
            'use strict';

            var d = require('../lib/dom')
              , h = require('../lib/helper')
              , instances = require('./instances');

            module.exports = function (element) {
              var i = instances.get(element);

              if (!i) {
                return;
              }

              i.event.unbindAll();
              d.remove(i.scrollbarX);
              d.remove(i.scrollbarY);
              d.remove(i.scrollbarXRail);
              d.remove(i.scrollbarYRail);
              h.removePsClasses(element);

              instances.remove(element);
            };

            },{"../lib/dom":3,"../lib/helper":6,"./instances":18}],10:[function(require,module,exports){
            'use strict';

            var h = require('../../lib/helper')
              , instances = require('../instances')
              , updateGeometry = require('../update-geometry')
              , updateScroll = require('../update-scroll');

            function bindClickRailHandler(element, i) {
              function pageOffset(el) {
                return el.getBoundingClientRect();
              }
              var stopPropagation = window.Event.prototype.stopPropagation.bind;

              if (i.settings.stopPropagationOnClick) {
                i.event.bind(i.scrollbarY, 'click', stopPropagation);
              }
              i.event.bind(i.scrollbarYRail, 'click', function (e) {
                var halfOfScrollbarLength = h.toInt(i.scrollbarYHeight / 2);
                var positionTop = i.railYRatio * (e.pageY - window.pageYOffset - pageOffset(i.scrollbarYRail).top - halfOfScrollbarLength);
                var maxPositionTop = i.railYRatio * (i.railYHeight - i.scrollbarYHeight);
                var positionRatio = positionTop / maxPositionTop;

                if (positionRatio < 0) {
                  positionRatio = 0;
                } else if (positionRatio > 1) {
                  positionRatio = 1;
                }

                updateScroll(element, 'top', (i.contentHeight - i.containerHeight) * positionRatio);
                updateGeometry(element);

                e.stopPropagation();
              });

              if (i.settings.stopPropagationOnClick) {
                i.event.bind(i.scrollbarX, 'click', stopPropagation);
              }
              i.event.bind(i.scrollbarXRail, 'click', function (e) {
                var halfOfScrollbarLength = h.toInt(i.scrollbarXWidth / 2);
                var positionLeft = i.railXRatio * (e.pageX - window.pageXOffset - pageOffset(i.scrollbarXRail).left - halfOfScrollbarLength);
                var maxPositionLeft = i.railXRatio * (i.railXWidth - i.scrollbarXWidth);
                var positionRatio = positionLeft / maxPositionLeft;

                if (positionRatio < 0) {
                  positionRatio = 0;
                } else if (positionRatio > 1) {
                  positionRatio = 1;
                }

                updateScroll(element, 'left', ((i.contentWidth - i.containerWidth) * positionRatio) - i.negativeScrollAdjustment);
                updateGeometry(element);

                e.stopPropagation();
              });
            }

            module.exports = function (element) {
              var i = instances.get(element);
              bindClickRailHandler(element, i);
            };

            },{"../../lib/helper":6,"../instances":18,"../update-geometry":19,"../update-scroll":20}],11:[function(require,module,exports){
            'use strict';

            var d = require('../../lib/dom')
              , h = require('../../lib/helper')
              , instances = require('../instances')
              , updateGeometry = require('../update-geometry')
              , updateScroll = require('../update-scroll');

            function bindMouseScrollXHandler(element, i) {
              var currentLeft = null;
              var currentPageX = null;

              function updateScrollLeft(deltaX) {
                var newLeft = currentLeft + (deltaX * i.railXRatio);
                var maxLeft = Math.max(0, i.scrollbarXRail.getBoundingClientRect().left) + (i.railXRatio * (i.railXWidth - i.scrollbarXWidth));

                if (newLeft < 0) {
                  i.scrollbarXLeft = 0;
                } else if (newLeft > maxLeft) {
                  i.scrollbarXLeft = maxLeft;
                } else {
                  i.scrollbarXLeft = newLeft;
                }

                var scrollLeft = h.toInt(i.scrollbarXLeft * (i.contentWidth - i.containerWidth) / (i.containerWidth - (i.railXRatio * i.scrollbarXWidth))) - i.negativeScrollAdjustment;
                updateScroll(element, 'left', scrollLeft);
              }

              var mouseMoveHandler = function (e) {
                updateScrollLeft(e.pageX - currentPageX);
                updateGeometry(element);
                e.stopPropagation();
                e.preventDefault();
              };

              var mouseUpHandler = function () {
                h.stopScrolling(element, 'x');
                i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
              };

              i.event.bind(i.scrollbarX, 'mousedown', function (e) {
                currentPageX = e.pageX;
                currentLeft = h.toInt(d.css(i.scrollbarX, 'left')) * i.railXRatio;
                h.startScrolling(element, 'x');

                i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
                i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

                e.stopPropagation();
                e.preventDefault();
              });
            }

            function bindMouseScrollYHandler(element, i) {
              var currentTop = null;
              var currentPageY = null;

              function updateScrollTop(deltaY) {
                var newTop = currentTop + (deltaY * i.railYRatio);
                var maxTop = Math.max(0, i.scrollbarYRail.getBoundingClientRect().top) + (i.railYRatio * (i.railYHeight - i.scrollbarYHeight));

                if (newTop < 0) {
                  i.scrollbarYTop = 0;
                } else if (newTop > maxTop) {
                  i.scrollbarYTop = maxTop;
                } else {
                  i.scrollbarYTop = newTop;
                }

                var scrollTop = h.toInt(i.scrollbarYTop * (i.contentHeight - i.containerHeight) / (i.containerHeight - (i.railYRatio * i.scrollbarYHeight)));
                updateScroll(element, 'top', scrollTop);
              }

              var mouseMoveHandler = function (e) {
                updateScrollTop(e.pageY - currentPageY);
                updateGeometry(element);
                e.stopPropagation();
                e.preventDefault();
              };

              var mouseUpHandler = function () {
                h.stopScrolling(element, 'y');
                i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
              };

              i.event.bind(i.scrollbarY, 'mousedown', function (e) {
                currentPageY = e.pageY;
                currentTop = h.toInt(d.css(i.scrollbarY, 'top')) * i.railYRatio;
                h.startScrolling(element, 'y');

                i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
                i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

                e.stopPropagation();
                e.preventDefault();
              });
            }

            module.exports = function (element) {
              var i = instances.get(element);
              bindMouseScrollXHandler(element, i);
              bindMouseScrollYHandler(element, i);
            };

            },{"../../lib/dom":3,"../../lib/helper":6,"../instances":18,"../update-geometry":19,"../update-scroll":20}],12:[function(require,module,exports){
            'use strict';

            var h = require('../../lib/helper')
              , d = require('../../lib/dom')
              , instances = require('../instances')
              , updateGeometry = require('../update-geometry')
              , updateScroll = require('../update-scroll');

            function bindKeyboardHandler(element, i) {
              var hovered = false;
              i.event.bind(element, 'mouseenter', function () {
                hovered = true;
              });
              i.event.bind(element, 'mouseleave', function () {
                hovered = false;
              });

              var shouldPrevent = false;
              function shouldPreventDefault(deltaX, deltaY) {
                var scrollTop = element.scrollTop;
                if (deltaX === 0) {
                  if (!i.scrollbarYActive) {
                    return false;
                  }
                  if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
                    return !i.settings.wheelPropagation;
                  }
                }

                var scrollLeft = element.scrollLeft;
                if (deltaY === 0) {
                  if (!i.scrollbarXActive) {
                    return false;
                  }
                  if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
                    return !i.settings.wheelPropagation;
                  }
                }
                return true;
              }

              i.event.bind(i.ownerDocument, 'keydown', function (e) {
                if (e.isDefaultPrevented && e.isDefaultPrevented()) {
                  return;
                }

                var focused = d.matches(i.scrollbarX, ':focus') ||
                              d.matches(i.scrollbarY, ':focus');

                if (!hovered && !focused) {
                  return;
                }

                var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
                if (activeElement) {
                  // go deeper if element is a webcomponent
                  while (activeElement.shadowRoot) {
                    activeElement = activeElement.shadowRoot.activeElement;
                  }
                  if (h.isEditable(activeElement)) {
                    return;
                  }
                }

                var deltaX = 0;
                var deltaY = 0;

                switch (e.which) {
                case 37: // left
                  deltaX = -30;
                  break;
                case 38: // up
                  deltaY = 30;
                  break;
                case 39: // right
                  deltaX = 30;
                  break;
                case 40: // down
                  deltaY = -30;
                  break;
                case 33: // page up
                  deltaY = 90;
                  break;
                case 32: // space bar
                  if (e.shiftKey) {
                    deltaY = 90;
                  } else {
                    deltaY = -90;
                  }
                  break;
                case 34: // page down
                  deltaY = -90;
                  break;
                case 35: // end
                  if (e.ctrlKey) {
                    deltaY = -i.contentHeight;
                  } else {
                    deltaY = -i.containerHeight;
                  }
                  break;
                case 36: // home
                  if (e.ctrlKey) {
                    deltaY = element.scrollTop;
                  } else {
                    deltaY = i.containerHeight;
                  }
                  break;
                default:
                  return;
                }

                updateScroll(element, 'top', element.scrollTop - deltaY);
                updateScroll(element, 'left', element.scrollLeft + deltaX);
                updateGeometry(element);

                shouldPrevent = shouldPreventDefault(deltaX, deltaY);
                if (shouldPrevent) {
                  e.preventDefault();
                }
              });
            }

            module.exports = function (element) {
              var i = instances.get(element);
              bindKeyboardHandler(element, i);
            };

            },{"../../lib/dom":3,"../../lib/helper":6,"../instances":18,"../update-geometry":19,"../update-scroll":20}],13:[function(require,module,exports){
            'use strict';

            var instances = require('../instances')
              , updateGeometry = require('../update-geometry')
              , updateScroll = require('../update-scroll');

            function bindMouseWheelHandler(element, i) {
              var shouldPrevent = false;

              function shouldPreventDefault(deltaX, deltaY) {
                var scrollTop = element.scrollTop;
                if (deltaX === 0) {
                  if (!i.scrollbarYActive) {
                    return false;
                  }
                  if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
                    return !i.settings.wheelPropagation;
                  }
                }

                var scrollLeft = element.scrollLeft;
                if (deltaY === 0) {
                  if (!i.scrollbarXActive) {
                    return false;
                  }
                  if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
                    return !i.settings.wheelPropagation;
                  }
                }
                return true;
              }

              function getDeltaFromEvent(e) {
                var deltaX = e.deltaX;
                var deltaY = -1 * e.deltaY;

                if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
                  // OS X Safari
                  deltaX = -1 * e.wheelDeltaX / 6;
                  deltaY = e.wheelDeltaY / 6;
                }

                if (e.deltaMode && e.deltaMode === 1) {
                  // Firefox in deltaMode 1: Line scrolling
                  deltaX *= 10;
                  deltaY *= 10;
                }

                if (deltaX !== deltaX && deltaY !== deltaY/* NaN checks */) {
                  // IE in some mouse drivers
                  deltaX = 0;
                  deltaY = e.wheelDelta;
                }

                return [deltaX, deltaY];
              }

              function shouldBeConsumedByTextarea(deltaX, deltaY) {
                var hoveredTextarea = element.querySelector('textarea:hover');
                if (hoveredTextarea) {
                  var maxScrollTop = hoveredTextarea.scrollHeight - hoveredTextarea.clientHeight;
                  if (maxScrollTop > 0) {
                    if (!(hoveredTextarea.scrollTop === 0 && deltaY > 0) &&
                        !(hoveredTextarea.scrollTop === maxScrollTop && deltaY < 0)) {
                      return true;
                    }
                  }
                  var maxScrollLeft = hoveredTextarea.scrollLeft - hoveredTextarea.clientWidth;
                  if (maxScrollLeft > 0) {
                    if (!(hoveredTextarea.scrollLeft === 0 && deltaX < 0) &&
                        !(hoveredTextarea.scrollLeft === maxScrollLeft && deltaX > 0)) {
                      return true;
                    }
                  }
                }
                return false;
              }

              function mousewheelHandler(e) {
                var delta = getDeltaFromEvent(e);

                var deltaX = delta[0];
                var deltaY = delta[1];

                if (shouldBeConsumedByTextarea(deltaX, deltaY)) {
                  return;
                }

                shouldPrevent = false;
                if (!i.settings.useBothWheelAxes) {
                  // deltaX will only be used for horizontal scrolling and deltaY will
                  // only be used for vertical scrolling - this is the default
                  updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
                  updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
                } else if (i.scrollbarYActive && !i.scrollbarXActive) {
                  // only vertical scrollbar is active and useBothWheelAxes option is
                  // active, so let's scroll vertical bar using both mouse wheel axes
                  if (deltaY) {
                    updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
                  } else {
                    updateScroll(element, 'top', element.scrollTop + (deltaX * i.settings.wheelSpeed));
                  }
                  shouldPrevent = true;
                } else if (i.scrollbarXActive && !i.scrollbarYActive) {
                  // useBothWheelAxes and only horizontal bar is active, so use both
                  // wheel axes for horizontal bar
                  if (deltaX) {
                    updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
                  } else {
                    updateScroll(element, 'left', element.scrollLeft - (deltaY * i.settings.wheelSpeed));
                  }
                  shouldPrevent = true;
                }

                updateGeometry(element);

                shouldPrevent = (shouldPrevent || shouldPreventDefault(deltaX, deltaY));
                if (shouldPrevent) {
                  e.stopPropagation();
                  e.preventDefault();
                }
              }

              if (typeof window.onwheel !== "undefined") {
                i.event.bind(element, 'wheel', mousewheelHandler);
              } else if (typeof window.onmousewheel !== "undefined") {
                i.event.bind(element, 'mousewheel', mousewheelHandler);
              }
            }

            module.exports = function (element) {
              var i = instances.get(element);
              bindMouseWheelHandler(element, i);
            };

            },{"../instances":18,"../update-geometry":19,"../update-scroll":20}],14:[function(require,module,exports){
            'use strict';

            var instances = require('../instances')
              , updateGeometry = require('../update-geometry');

            function bindNativeScrollHandler(element, i) {
              i.event.bind(element, 'scroll', function () {
                updateGeometry(element);
              });
            }

            module.exports = function (element) {
              var i = instances.get(element);
              bindNativeScrollHandler(element, i);
            };

            },{"../instances":18,"../update-geometry":19}],15:[function(require,module,exports){
            'use strict';

            var h = require('../../lib/helper')
              , instances = require('../instances')
              , updateGeometry = require('../update-geometry')
              , updateScroll = require('../update-scroll');

            function bindSelectionHandler(element, i) {
              function getRangeNode() {
                var selection = window.getSelection ? window.getSelection() :
                                document.getSelection ? document.getSelection() : '';
                if (selection.toString().length === 0) {
                  return null;
                } else {
                  return selection.getRangeAt(0).commonAncestorContainer;
                }
              }

              var scrollingLoop = null;
              var scrollDiff = {top: 0, left: 0};
              function startScrolling() {
                if (!scrollingLoop) {
                  scrollingLoop = setInterval(function () {
                    if (!instances.get(element)) {
                      clearInterval(scrollingLoop);
                      return;
                    }

                    updateScroll(element, 'top', element.scrollTop + scrollDiff.top);
                    updateScroll(element, 'left', element.scrollLeft + scrollDiff.left);
                    updateGeometry(element);
                  }, 50); // every .1 sec
                }
              }
              function stopScrolling() {
                if (scrollingLoop) {
                  clearInterval(scrollingLoop);
                  scrollingLoop = null;
                }
                h.stopScrolling(element);
              }

              var isSelected = false;
              i.event.bind(i.ownerDocument, 'selectionchange', function () {
                if (element.contains(getRangeNode())) {
                  isSelected = true;
                } else {
                  isSelected = false;
                  stopScrolling();
                }
              });
              i.event.bind(window, 'mouseup', function () {
                if (isSelected) {
                  isSelected = false;
                  stopScrolling();
                }
              });

              i.event.bind(window, 'mousemove', function (e) {
                if (isSelected) {
                  var mousePosition = {x: e.pageX, y: e.pageY};
                  var containerGeometry = {
                    left: element.offsetLeft,
                    right: element.offsetLeft + element.offsetWidth,
                    top: element.offsetTop,
                    bottom: element.offsetTop + element.offsetHeight
                  };

                  if (mousePosition.x < containerGeometry.left + 3) {
                    scrollDiff.left = -5;
                    h.startScrolling(element, 'x');
                  } else if (mousePosition.x > containerGeometry.right - 3) {
                    scrollDiff.left = 5;
                    h.startScrolling(element, 'x');
                  } else {
                    scrollDiff.left = 0;
                  }

                  if (mousePosition.y < containerGeometry.top + 3) {
                    if (containerGeometry.top + 3 - mousePosition.y < 5) {
                      scrollDiff.top = -5;
                    } else {
                      scrollDiff.top = -20;
                    }
                    h.startScrolling(element, 'y');
                  } else if (mousePosition.y > containerGeometry.bottom - 3) {
                    if (mousePosition.y - containerGeometry.bottom + 3 < 5) {
                      scrollDiff.top = 5;
                    } else {
                      scrollDiff.top = 20;
                    }
                    h.startScrolling(element, 'y');
                  } else {
                    scrollDiff.top = 0;
                  }

                  if (scrollDiff.top === 0 && scrollDiff.left === 0) {
                    stopScrolling();
                  } else {
                    startScrolling();
                  }
                }
              });
            }

            module.exports = function (element) {
              var i = instances.get(element);
              bindSelectionHandler(element, i);
            };

            },{"../../lib/helper":6,"../instances":18,"../update-geometry":19,"../update-scroll":20}],16:[function(require,module,exports){
            'use strict';

            var instances = require('../instances')
              , updateGeometry = require('../update-geometry')
              , updateScroll = require('../update-scroll');

            function bindTouchHandler(element, i, supportsTouch, supportsIePointer) {
              function shouldPreventDefault(deltaX, deltaY) {
                var scrollTop = element.scrollTop;
                var scrollLeft = element.scrollLeft;
                var magnitudeX = Math.abs(deltaX);
                var magnitudeY = Math.abs(deltaY);

                if (magnitudeY > magnitudeX) {
                  // user is perhaps trying to swipe up/down the page

                  if (((deltaY < 0) && (scrollTop === i.contentHeight - i.containerHeight)) ||
                      ((deltaY > 0) && (scrollTop === 0))) {
                    return !i.settings.swipePropagation;
                  }
                } else if (magnitudeX > magnitudeY) {
                  // user is perhaps trying to swipe left/right across the page

                  if (((deltaX < 0) && (scrollLeft === i.contentWidth - i.containerWidth)) ||
                      ((deltaX > 0) && (scrollLeft === 0))) {
                    return !i.settings.swipePropagation;
                  }
                }

                return true;
              }

              function applyTouchMove(differenceX, differenceY) {
                updateScroll(element, 'top', element.scrollTop - differenceY);
                updateScroll(element, 'left', element.scrollLeft - differenceX);

                updateGeometry(element);
              }

              var startOffset = {};
              var startTime = 0;
              var speed = {};
              var easingLoop = null;
              var inGlobalTouch = false;
              var inLocalTouch = false;

              function globalTouchStart() {
                inGlobalTouch = true;
              }
              function globalTouchEnd() {
                inGlobalTouch = false;
              }

              function getTouch(e) {
                if (e.targetTouches) {
                  return e.targetTouches[0];
                } else {
                  // Maybe IE pointer
                  return e;
                }
              }
              function shouldHandle(e) {
                if (e.targetTouches && e.targetTouches.length === 1) {
                  return true;
                }
                if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
                  return true;
                }
                return false;
              }
              function touchStart(e) {
                if (shouldHandle(e)) {
                  inLocalTouch = true;

                  var touch = getTouch(e);

                  startOffset.pageX = touch.pageX;
                  startOffset.pageY = touch.pageY;

                  startTime = (new Date()).getTime();

                  if (easingLoop !== null) {
                    clearInterval(easingLoop);
                  }

                  e.stopPropagation();
                }
              }
              function touchMove(e) {
                if (!inGlobalTouch && inLocalTouch && shouldHandle(e)) {
                  var touch = getTouch(e);

                  var currentOffset = {pageX: touch.pageX, pageY: touch.pageY};

                  var differenceX = currentOffset.pageX - startOffset.pageX;
                  var differenceY = currentOffset.pageY - startOffset.pageY;

                  applyTouchMove(differenceX, differenceY);
                  startOffset = currentOffset;

                  var currentTime = (new Date()).getTime();

                  var timeGap = currentTime - startTime;
                  if (timeGap > 0) {
                    speed.x = differenceX / timeGap;
                    speed.y = differenceY / timeGap;
                    startTime = currentTime;
                  }

                  if (shouldPreventDefault(differenceX, differenceY)) {
                    e.stopPropagation();
                    e.preventDefault();
                  }
                }
              }
              function touchEnd() {
                if (!inGlobalTouch && inLocalTouch) {
                  inLocalTouch = false;

                  clearInterval(easingLoop);
                  easingLoop = setInterval(function () {
                    if (!instances.get(element)) {
                      clearInterval(easingLoop);
                      return;
                    }

                    if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
                      clearInterval(easingLoop);
                      return;
                    }

                    applyTouchMove(speed.x * 30, speed.y * 30);

                    speed.x *= 0.8;
                    speed.y *= 0.8;
                  }, 10);
                }
              }

              if (supportsTouch) {
                i.event.bind(window, 'touchstart', globalTouchStart);
                i.event.bind(window, 'touchend', globalTouchEnd);
                i.event.bind(element, 'touchstart', touchStart);
                i.event.bind(element, 'touchmove', touchMove);
                i.event.bind(element, 'touchend', touchEnd);
              }

              if (supportsIePointer) {
                if (window.PointerEvent) {
                  i.event.bind(window, 'pointerdown', globalTouchStart);
                  i.event.bind(window, 'pointerup', globalTouchEnd);
                  i.event.bind(element, 'pointerdown', touchStart);
                  i.event.bind(element, 'pointermove', touchMove);
                  i.event.bind(element, 'pointerup', touchEnd);
                } else if (window.MSPointerEvent) {
                  i.event.bind(window, 'MSPointerDown', globalTouchStart);
                  i.event.bind(window, 'MSPointerUp', globalTouchEnd);
                  i.event.bind(element, 'MSPointerDown', touchStart);
                  i.event.bind(element, 'MSPointerMove', touchMove);
                  i.event.bind(element, 'MSPointerUp', touchEnd);
                }
              }
            }

            module.exports = function (element, supportsTouch, supportsIePointer) {
              var i = instances.get(element);
              bindTouchHandler(element, i, supportsTouch, supportsIePointer);
            };

            },{"../instances":18,"../update-geometry":19,"../update-scroll":20}],17:[function(require,module,exports){
            'use strict';

            var cls = require('../lib/class')
              , h = require('../lib/helper')
              , instances = require('./instances')
              , updateGeometry = require('./update-geometry');

            // Handlers
            var clickRailHandler = require('./handler/click-rail')
              , dragScrollbarHandler = require('./handler/drag-scrollbar')
              , keyboardHandler = require('./handler/keyboard')
              , mouseWheelHandler = require('./handler/mouse-wheel')
              , nativeScrollHandler = require('./handler/native-scroll')
              , selectionHandler = require('./handler/selection')
              , touchHandler = require('./handler/touch');

            module.exports = function (element, userSettings) {
              userSettings = typeof userSettings === 'object' ? userSettings : {};

              cls.add(element, 'ps-container');

              // Create a plugin instance.
              var i = instances.add(element);

              i.settings = h.extend(i.settings, userSettings);
              cls.add(element, 'ps-theme-' + i.settings.theme);

              clickRailHandler(element);
              dragScrollbarHandler(element);
              mouseWheelHandler(element);
              nativeScrollHandler(element);

              if (i.settings.useSelectionScroll) {
                selectionHandler(element);
              }

              if (h.env.supportsTouch || h.env.supportsIePointer) {
                touchHandler(element, h.env.supportsTouch, h.env.supportsIePointer);
              }
              if (i.settings.useKeyboard) {
                keyboardHandler(element);
              }

              updateGeometry(element);
            };

            },{"../lib/class":2,"../lib/helper":6,"./handler/click-rail":10,"./handler/drag-scrollbar":11,"./handler/keyboard":12,"./handler/mouse-wheel":13,"./handler/native-scroll":14,"./handler/selection":15,"./handler/touch":16,"./instances":18,"./update-geometry":19}],18:[function(require,module,exports){
            'use strict';

            var cls = require('../lib/class')
              , d = require('../lib/dom')
              , defaultSettings = require('./default-setting')
              , EventManager = require('../lib/event-manager')
              , guid = require('../lib/guid')
              , h = require('../lib/helper');

            var instances = {};

            function Instance(element) {
              var i = this;

              i.settings = h.clone(defaultSettings);
              i.containerWidth = null;
              i.containerHeight = null;
              i.contentWidth = null;
              i.contentHeight = null;

              i.isRtl = d.css(element, 'direction') === "rtl";
              i.isNegativeScroll = (function () {
                var originalScrollLeft = element.scrollLeft;
                var result = null;
                element.scrollLeft = -1;
                result = element.scrollLeft < 0;
                element.scrollLeft = originalScrollLeft;
                return result;
              })();
              i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
              i.event = new EventManager();
              i.ownerDocument = element.ownerDocument || document;

              function focus() {
                cls.add(element, 'ps-focus');
              }

              function blur() {
                cls.remove(element, 'ps-focus');
              }

              i.scrollbarXRail = d.appendTo(d.e('div', 'ps-scrollbar-x-rail'), element);
              i.scrollbarX = d.appendTo(d.e('div', 'ps-scrollbar-x'), i.scrollbarXRail);
              i.scrollbarX.setAttribute('tabindex', 0);
              i.event.bind(i.scrollbarX, 'focus', focus);
              i.event.bind(i.scrollbarX, 'blur', blur);
              i.scrollbarXActive = null;
              i.scrollbarXWidth = null;
              i.scrollbarXLeft = null;
              i.scrollbarXBottom = h.toInt(d.css(i.scrollbarXRail, 'bottom'));
              i.isScrollbarXUsingBottom = i.scrollbarXBottom === i.scrollbarXBottom; // !isNaN
              i.scrollbarXTop = i.isScrollbarXUsingBottom ? null : h.toInt(d.css(i.scrollbarXRail, 'top'));
              i.railBorderXWidth = h.toInt(d.css(i.scrollbarXRail, 'borderLeftWidth')) + h.toInt(d.css(i.scrollbarXRail, 'borderRightWidth'));
              // Set rail to display:block to calculate margins
              d.css(i.scrollbarXRail, 'display', 'block');
              i.railXMarginWidth = h.toInt(d.css(i.scrollbarXRail, 'marginLeft')) + h.toInt(d.css(i.scrollbarXRail, 'marginRight'));
              d.css(i.scrollbarXRail, 'display', '');
              i.railXWidth = null;
              i.railXRatio = null;

              i.scrollbarYRail = d.appendTo(d.e('div', 'ps-scrollbar-y-rail'), element);
              i.scrollbarY = d.appendTo(d.e('div', 'ps-scrollbar-y'), i.scrollbarYRail);
              i.scrollbarY.setAttribute('tabindex', 0);
              i.event.bind(i.scrollbarY, 'focus', focus);
              i.event.bind(i.scrollbarY, 'blur', blur);
              i.scrollbarYActive = null;
              i.scrollbarYHeight = null;
              i.scrollbarYTop = null;
              i.scrollbarYRight = h.toInt(d.css(i.scrollbarYRail, 'right'));
              i.isScrollbarYUsingRight = i.scrollbarYRight === i.scrollbarYRight; // !isNaN
              i.scrollbarYLeft = i.isScrollbarYUsingRight ? null : h.toInt(d.css(i.scrollbarYRail, 'left'));
              i.scrollbarYOuterWidth = i.isRtl ? h.outerWidth(i.scrollbarY) : null;
              i.railBorderYWidth = h.toInt(d.css(i.scrollbarYRail, 'borderTopWidth')) + h.toInt(d.css(i.scrollbarYRail, 'borderBottomWidth'));
              d.css(i.scrollbarYRail, 'display', 'block');
              i.railYMarginHeight = h.toInt(d.css(i.scrollbarYRail, 'marginTop')) + h.toInt(d.css(i.scrollbarYRail, 'marginBottom'));
              d.css(i.scrollbarYRail, 'display', '');
              i.railYHeight = null;
              i.railYRatio = null;
            }

            function getId(element) {
              if (typeof element.dataset === 'undefined') {
                return element.getAttribute('data-ps-id');
              } else {
                return element.dataset.psId;
              }
            }

            function setId(element, id) {
              if (typeof element.dataset === 'undefined') {
                element.setAttribute('data-ps-id', id);
              } else {
                element.dataset.psId = id;
              }
            }

            function removeId(element) {
              if (typeof element.dataset === 'undefined') {
                element.removeAttribute('data-ps-id');
              } else {
                delete element.dataset.psId;
              }
            }

            exports.add = function (element) {
              var newId = guid();
              setId(element, newId);
              instances[newId] = new Instance(element);
              return instances[newId];
            };

            exports.remove = function (element) {
              delete instances[getId(element)];
              removeId(element);
            };

            exports.get = function (element) {
              return instances[getId(element)];
            };

            },{"../lib/class":2,"../lib/dom":3,"../lib/event-manager":4,"../lib/guid":5,"../lib/helper":6,"./default-setting":8}],19:[function(require,module,exports){
            'use strict';

            var cls = require('../lib/class')
              , d = require('../lib/dom')
              , h = require('../lib/helper')
              , instances = require('./instances')
              , updateScroll = require('./update-scroll');

            function getThumbSize(i, thumbSize) {
              if (i.settings.minScrollbarLength) {
                thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
              }
              if (i.settings.maxScrollbarLength) {
                thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
              }
              return thumbSize;
            }

            function updateCss(element, i) {
              var xRailOffset = {width: i.railXWidth};
              if (i.isRtl) {
                xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
              } else {
                xRailOffset.left = element.scrollLeft;
              }
              if (i.isScrollbarXUsingBottom) {
                xRailOffset.bottom = i.scrollbarXBottom - element.scrollTop;
              } else {
                xRailOffset.top = i.scrollbarXTop + element.scrollTop;
              }
              d.css(i.scrollbarXRail, xRailOffset);

              var yRailOffset = {top: element.scrollTop, height: i.railYHeight};
              if (i.isScrollbarYUsingRight) {
                if (i.isRtl) {
                  yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth;
                } else {
                  yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
                }
              } else {
                if (i.isRtl) {
                  yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
                } else {
                  yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
                }
              }
              d.css(i.scrollbarYRail, yRailOffset);

              d.css(i.scrollbarX, {left: i.scrollbarXLeft, width: i.scrollbarXWidth - i.railBorderXWidth});
              d.css(i.scrollbarY, {top: i.scrollbarYTop, height: i.scrollbarYHeight - i.railBorderYWidth});
            }

            module.exports = function (element) {
              var i = instances.get(element);

              i.containerWidth = element.clientWidth;
              i.containerHeight = element.clientHeight;
              i.contentWidth = element.scrollWidth;
              i.contentHeight = element.scrollHeight;

              var existingRails;
              if (!element.contains(i.scrollbarXRail)) {
                existingRails = d.queryChildren(element, '.ps-scrollbar-x-rail');
                if (existingRails.length > 0) {
                  existingRails.forEach(function (rail) {
                    d.remove(rail);
                  });
                }
                d.appendTo(i.scrollbarXRail, element);
              }
              if (!element.contains(i.scrollbarYRail)) {
                existingRails = d.queryChildren(element, '.ps-scrollbar-y-rail');
                if (existingRails.length > 0) {
                  existingRails.forEach(function (rail) {
                    d.remove(rail);
                  });
                }
                d.appendTo(i.scrollbarYRail, element);
              }

              if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
                i.scrollbarXActive = true;
                i.railXWidth = i.containerWidth - i.railXMarginWidth;
                i.railXRatio = i.containerWidth / i.railXWidth;
                i.scrollbarXWidth = getThumbSize(i, h.toInt(i.railXWidth * i.containerWidth / i.contentWidth));
                i.scrollbarXLeft = h.toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
              } else {
                i.scrollbarXActive = false;
              }

              if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
                i.scrollbarYActive = true;
                i.railYHeight = i.containerHeight - i.railYMarginHeight;
                i.railYRatio = i.containerHeight / i.railYHeight;
                i.scrollbarYHeight = getThumbSize(i, h.toInt(i.railYHeight * i.containerHeight / i.contentHeight));
                i.scrollbarYTop = h.toInt(element.scrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
              } else {
                i.scrollbarYActive = false;
              }

              if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
                i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
              }
              if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
                i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
              }

              updateCss(element, i);

              if (i.scrollbarXActive) {
                cls.add(element, 'ps-active-x');
              } else {
                cls.remove(element, 'ps-active-x');
                i.scrollbarXWidth = 0;
                i.scrollbarXLeft = 0;
                updateScroll(element, 'left', 0);
              }
              if (i.scrollbarYActive) {
                cls.add(element, 'ps-active-y');
              } else {
                cls.remove(element, 'ps-active-y');
                i.scrollbarYHeight = 0;
                i.scrollbarYTop = 0;
                updateScroll(element, 'top', 0);
              }
            };

            },{"../lib/class":2,"../lib/dom":3,"../lib/helper":6,"./instances":18,"./update-scroll":20}],20:[function(require,module,exports){
            'use strict';

            var instances = require('./instances');

            var upEvent = document.createEvent('Event')
              , downEvent = document.createEvent('Event')
              , leftEvent = document.createEvent('Event')
              , rightEvent = document.createEvent('Event')
              , yEvent = document.createEvent('Event')
              , xEvent = document.createEvent('Event')
              , xStartEvent = document.createEvent('Event')
              , xEndEvent = document.createEvent('Event')
              , yStartEvent = document.createEvent('Event')
              , yEndEvent = document.createEvent('Event')
              , lastTop
              , lastLeft;

            upEvent.initEvent('ps-scroll-up', true, true);
            downEvent.initEvent('ps-scroll-down', true, true);
            leftEvent.initEvent('ps-scroll-left', true, true);
            rightEvent.initEvent('ps-scroll-right', true, true);
            yEvent.initEvent('ps-scroll-y', true, true);
            xEvent.initEvent('ps-scroll-x', true, true);
            xStartEvent.initEvent('ps-x-reach-start', true, true);
            xEndEvent.initEvent('ps-x-reach-end', true, true);
            yStartEvent.initEvent('ps-y-reach-start', true, true);
            yEndEvent.initEvent('ps-y-reach-end', true, true);

            module.exports = function (element, axis, value) {
              if (typeof element === 'undefined') {
                throw 'You must provide an element to the update-scroll function';
              }

              if (typeof axis === 'undefined') {
                throw 'You must provide an axis to the update-scroll function';
              }

              if (typeof value === 'undefined') {
                throw 'You must provide a value to the update-scroll function';
              }

              if (axis === 'top' && value <= 0) {
                element.scrollTop = value = 0; // don't allow negative scroll
                element.dispatchEvent(yStartEvent);
              }

              if (axis === 'left' && value <= 0) {
                element.scrollLeft = value = 0; // don't allow negative scroll
                element.dispatchEvent(xStartEvent);
              }

              var i = instances.get(element);

              if (axis === 'top' && value >= i.contentHeight - i.containerHeight) {
                element.scrollTop = value = i.contentHeight - i.containerHeight; // don't allow scroll past container
                element.dispatchEvent(yEndEvent);
              }

              if (axis === 'left' && value >= i.contentWidth - i.containerWidth) {
                element.scrollLeft = value = i.contentWidth - i.containerWidth; // don't allow scroll past container
                element.dispatchEvent(xEndEvent);
              }

              if (!lastTop) {
                lastTop = element.scrollTop;
              }

              if (!lastLeft) {
                lastLeft = element.scrollLeft;
              }

              if (axis === 'top' && value < lastTop) {
                element.dispatchEvent(upEvent);
              }

              if (axis === 'top' && value > lastTop) {
                element.dispatchEvent(downEvent);
              }

              if (axis === 'left' && value < lastLeft) {
                element.dispatchEvent(leftEvent);
              }

              if (axis === 'left' && value > lastLeft) {
                element.dispatchEvent(rightEvent);
              }

              if (axis === 'top') {
                element.scrollTop = lastTop = value;
                element.dispatchEvent(yEvent);
              }

              if (axis === 'left') {
                element.scrollLeft = lastLeft = value;
                element.dispatchEvent(xEvent);
              }

            };

            },{"./instances":18}],21:[function(require,module,exports){
            'use strict';

            var d = require('../lib/dom')
              , h = require('../lib/helper')
              , instances = require('./instances')
              , updateGeometry = require('./update-geometry')
              , updateScroll = require('./update-scroll');

            module.exports = function (element) {
              var i = instances.get(element);

              if (!i) {
                return;
              }

              // Recalcuate negative scrollLeft adjustment
              i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;

              // Recalculate rail margins
              d.css(i.scrollbarXRail, 'display', 'block');
              d.css(i.scrollbarYRail, 'display', 'block');
              i.railXMarginWidth = h.toInt(d.css(i.scrollbarXRail, 'marginLeft')) + h.toInt(d.css(i.scrollbarXRail, 'marginRight'));
              i.railYMarginHeight = h.toInt(d.css(i.scrollbarYRail, 'marginTop')) + h.toInt(d.css(i.scrollbarYRail, 'marginBottom'));

              // Hide scrollbars not to affect scrollWidth and scrollHeight
              d.css(i.scrollbarXRail, 'display', 'none');
              d.css(i.scrollbarYRail, 'display', 'none');

              updateGeometry(element);

              // Update top/left scroll to trigger events
              updateScroll(element, 'top', element.scrollTop);
              updateScroll(element, 'left', element.scrollLeft);

              d.css(i.scrollbarXRail, 'display', '');
              d.css(i.scrollbarYRail, 'display', '');
            };

            },{"../lib/dom":3,"../lib/helper":6,"./instances":18,"./update-geometry":19,"./update-scroll":20}]},{},[1]);
        },
        sparkline_Js(){
            
        },
        waves_Js(){
            !function(t){
                "use strict";function e(t){return null!==t&&t===t.window}function n(t){return e(t)?t:9===t.nodeType&&t.defaultView}function a(t){var e,a,i={top:0,left:0},o=t&&t.ownerDocument;return e=o.documentElement,"undefined"!=typeof t.getBoundingClientRect&&(i=t.getBoundingClientRect()),a=n(o),{top:i.top+a.pageYOffset-e.clientTop,left:i.left+a.pageXOffset-e.clientLeft}}function i(t){var e="";for(var n in t)t.hasOwnProperty(n)&&(e+=n+":"+t[n]+";");return e}function o(t){if(d.allowEvent(t)===!1)return null;for(var e=null,n=t.target||t.srcElement;null!==n.parentElement;){if(!(n instanceof SVGElement||-1===n.className.indexOf("waves-effect"))){e=n;break}if(n.classList.contains("waves-effect")){e=n;break}n=n.parentElement}return e}function r(e){var n=o(e);null!==n&&(c.show(e,n),"ontouchstart"in t&&(n.addEventListener("touchend",c.hide,!1),n.addEventListener("touchcancel",c.hide,!1)),n.addEventListener("mouseup",c.hide,!1),n.addEventListener("mouseleave",c.hide,!1))}var s=s||{},u=document.querySelectorAll.bind(document),c={duration:750,show:function(t,e){if(2===t.button)return!1;var n=e||this,o=document.createElement("div");o.className="waves-ripple",n.appendChild(o);var r=a(n),s=t.pageY-r.top,u=t.pageX-r.left,d="scale("+n.clientWidth/100*10+")";"touches"in t&&(s=t.touches[0].pageY-r.top,u=t.touches[0].pageX-r.left),o.setAttribute("data-hold",Date.now()),o.setAttribute("data-scale",d),o.setAttribute("data-x",u),o.setAttribute("data-y",s);var l={top:s+"px",left:u+"px"};o.className=o.className+" waves-notransition",o.setAttribute("style",i(l)),o.className=o.className.replace("waves-notransition",""),l["-webkit-transform"]=d,l["-moz-transform"]=d,l["-ms-transform"]=d,l["-o-transform"]=d,l.transform=d,l.opacity="1",l["-webkit-transition-duration"]=c.duration+"ms",l["-moz-transition-duration"]=c.duration+"ms",l["-o-transition-duration"]=c.duration+"ms",l["transition-duration"]=c.duration+"ms",l["-webkit-transition-timing-function"]="cubic-bezier(0.250, 0.460, 0.450, 0.940)",l["-moz-transition-timing-function"]="cubic-bezier(0.250, 0.460, 0.450, 0.940)",l["-o-transition-timing-function"]="cubic-bezier(0.250, 0.460, 0.450, 0.940)",l["transition-timing-function"]="cubic-bezier(0.250, 0.460, 0.450, 0.940)",o.setAttribute("style",i(l))},hide:function(t){d.touchup(t);var e=this,n=(1.4*e.clientWidth,null),a=e.getElementsByClassName("waves-ripple");if(!(a.length>0))return!1;n=a[a.length-1];var o=n.getAttribute("data-x"),r=n.getAttribute("data-y"),s=n.getAttribute("data-scale"),u=Date.now()-Number(n.getAttribute("data-hold")),l=350-u;0>l&&(l=0),setTimeout(function(){var t={top:r+"px",left:o+"px",opacity:"0","-webkit-transition-duration":c.duration+"ms","-moz-transition-duration":c.duration+"ms","-o-transition-duration":c.duration+"ms","transition-duration":c.duration+"ms","-webkit-transform":s,"-moz-transform":s,"-ms-transform":s,"-o-transform":s,transform:s};n.setAttribute("style",i(t)),setTimeout(function(){try{e.removeChild(n)}catch(t){return!1}},c.duration)},l)},wrapInput:function(t){for(var e=0;e<t.length;e++){var n=t[e];if("input"===n.tagName.toLowerCase()){var a=n.parentNode;if("i"===a.tagName.toLowerCase()&&-1!==a.className.indexOf("waves-effect"))continue;var i=document.createElement("i");i.className=n.className+" waves-input-wrapper";var o=n.getAttribute("style");o||(o=""),i.setAttribute("style",o),n.className="waves-button-input",n.removeAttribute("style"),a.replaceChild(i,n),i.appendChild(n)}}}},d={touches:0,allowEvent:function(t){var e=!0;return"touchstart"===t.type?d.touches+=1:"touchend"===t.type||"touchcancel"===t.type?setTimeout(function(){d.touches>0&&(d.touches-=1)},500):"mousedown"===t.type&&d.touches>0&&(e=!1),e},touchup:function(t){d.allowEvent(t)}};s.displayEffect=function(e){e=e||{},"duration"in e&&(c.duration=e.duration),c.wrapInput(u(".waves-effect")),"ontouchstart"in t&&document.body.addEventListener("touchstart",r,!1),document.body.addEventListener("mousedown",r,!1)},s.attach=function(e){"input"===e.tagName.toLowerCase()&&(c.wrapInput([e]),e=e.parentElement),"ontouchstart"in t&&e.addEventListener("touchstart",r,!1),e.addEventListener("mousedown",r,!1)},t.Waves=s,document.addEventListener("DOMContentLoaded",function(){s.displayEffect()},!1)}(window);
        },
        sidebarmenu_Js(){
            $(function() {
                "use strict";
                 var url = window.location + "";
                    var path = url.replace(window.location.protocol + "//" + window.location.host + "/", "");
                    var element = $('ul#sidebarnav a').filter(function() {
                        return this.href === url || this.href === path;// || url.href.indexOf(this.href) === 0;
                    });
                    element.parentsUntil(".sidebar-nav").each(function (index)
                    {
                        if($(this).is("li") && $(this).children("a").length !== 0)
                        {
                            $(this).children("a").addClass("active");
                            $(this).parent("ul#sidebarnav").length === 0
                                ? $(this).addClass("active")
                                : $(this).addClass("selected");
                        }
                        else if(!$(this).is("ul") && $(this).children("a").length === 0)
                        {
                            $(this).addClass("selected");
                            
                        }
                        else if($(this).is("ul")){
                            $(this).addClass('in');
                        }
                        
                    });

                element.addClass("active"); 
                $('#sidebarnav a').on('click', function (e) {
                    
                        if (!$(this).hasClass("active")) {
                            // hide any open menus and remove all other classes
                            $("ul", $(this).parents("ul:first")).removeClass("in");
                            $("a", $(this).parents("ul:first")).removeClass("active");
                            
                            // open our new menu and add the open class
                            $(this).next("ul").addClass("in");
                            $(this).addClass("active");
                            
                        }
                        else if ($(this).hasClass("active")) {
                            $(this).removeClass("active");
                            $(this).parents("ul:first").removeClass("active");
                            $(this).next("ul").removeClass("in");
                        }
                })
                $('#sidebarnav >li >a.has-arrow').on('click', function (e) {
                    e.preventDefault();
                });
                
            });
        },
        custom_Js(){
            $(function() {
              'use strict';
              // ==============================================================
              // Theme options
              // ==============================================================
              // ==============================================================
              // sidebar-hover
              // ==============================================================

              $('.left-sidebar').hover(
                function() {
                  $('.navbar-header').addClass('expand-logo');
                },
                function() {
                  $('.navbar-header').removeClass('expand-logo');
                }
              );
              // this is for close icon when navigation open in mobile view
              $('.nav-toggler').on('click', function() {
                $('#main-wrapper').toggleClass('show-sidebar');
                $('.nav-toggler i').toggleClass('ti-menu');
              });
              $('.nav-lock').on('click', function() {
                $('body').toggleClass('lock-nav');
                $('.nav-lock i').toggleClass('mdi-toggle-switch-off');
                $('body, .page-wrapper').trigger('resize');
              });
              $('.search-box a, .search-box .app-search .srh-btn').on('click', function() {
                $('.app-search').toggle(200);
                $('.app-search input').focus();
              });

              // ==============================================================
              // Right sidebar options
              // ==============================================================
              $(function() {
                $('.service-panel-toggle').on('click', function() {
                  $('.customizer').toggleClass('show-service-panel');
                });
                $('.page-wrapper').on('click', function() {
                  $('.customizer').removeClass('show-service-panel');
                });
              });
              // ==============================================================
              // This is for the floating labels
              // ==============================================================
              $('.floating-labels .form-control')
                .on('focus blur', function(e) {
                  $(this)
                    .parents('.form-group')
                    .toggleClass('focused', e.type === 'focus' || this.value.length > 0);
                })
                .trigger('blur');

              // ==============================================================
              //tooltip
              // ==============================================================
              $(function() {
                $('[data-toggle="tooltip"]').tooltip();
              });
              // ==============================================================
              //Popover
              // ==============================================================
              $(function() {
                $('[data-toggle="popover"]').popover();
              });

              // ==============================================================
              // Perfact scrollbar
              // ==============================================================
              $('.message-center, .customizer-body, .scrollable').perfectScrollbar({
                wheelPropagation: !0
              });

              /*var ps = new PerfectScrollbar('.message-body');
                var ps = new PerfectScrollbar('.notifications');
                var ps = new PerfectScrollbar('.scroll-sidebar');
                var ps = new PerfectScrollbar('.customizer-body');*/

              // ==============================================================
              // Resize all elements
              // ==============================================================
              $('body, .page-wrapper').trigger('resize');
              $('.page-wrapper')
                .delay(20)
                .show();
              // ==============================================================
              // To do list
              // ==============================================================
              $('.list-task li label').click(function() {
                $(this).toggleClass('task-done');
              });
              // ==============================================================
              // Collapsable cards
              // ==============================================================
              $('a[data-action="collapse"]').on('click', function(e) {
                e.preventDefault();
                $(this)
                  .closest('.card')
                  .find('[data-action="collapse"] i')
                  .toggleClass('ti-minus ti-plus');
                $(this)
                  .closest('.card')
                  .children('.card-body')
                  .collapse('toggle');
              });
              // Toggle fullscreen
              $('a[data-action="expand"]').on('click', function(e) {
                e.preventDefault();
                $(this)
                  .closest('.card')
                  .find('[data-action="expand"] i')
                  .toggleClass('mdi-arrow-expand mdi-arrow-compress');
                $(this)
                  .closest('.card')
                  .toggleClass('card-fullscreen');
              });
              // Close Card
              $('a[data-action="close"]').on('click', function() {
                $(this)
                  .closest('.card')
                  .removeClass()
                  .slideUp('fast');
              });
              // ==============================================================
              // LThis is for mega menu
              // ==============================================================
              $(document).on('click', '.mega-dropdown', function(e) {
                e.stopPropagation();
              });
              // ==============================================================
              // Last month earning
              // ==============================================================
              var sparklineLogin = function() {
                $('.lastmonth').sparkline([6, 10, 9, 11, 9, 10, 12], {
                  type: 'bar',
                  height: '35',
                  barWidth: '4',
                  width: '100%',
                  resize: true,
                  barSpacing: '8',
                  barColor: '#2961ff'
                });
              };
              var sparkResize;

              $(window).resize(function(e) {
                clearTimeout(sparkResize);
                sparkResize = setTimeout(sparklineLogin, 500);
              });
              sparklineLogin();

              // ==============================================================
              // This is for the innerleft sidebar
              // ==============================================================
              $('.show-left-part').on('click', function() {
                $('.left-part').toggleClass('show-panel');
                $('.show-left-part').toggleClass('ti-menu');
              });

              // Disable right click and f12
              /*
                $("html").on("contextmenu",function(e){
                   return false;
                });
                $(document).keydown(function (event) {
                    if (event.keyCode == 123) { // Prevent F12
                        return false;
                    } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I        
                        return false;
                    }   
                }); */

                // For Custom File Input
                  $('.custom-file-input').on('change',function(){
                      //get the file name
                      var fileName = $(this).val();
                      //replace the "Choose a file" label
                      $(this).next('.custom-file-label').html(fileName);
                  })
            });
        }
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AppLms/Functions/Menu.vue